import { render } from "./RoundCard.vue?vue&type=template&id=c91f04a6&scoped=true"
import script from "./RoundCard.vue?vue&type=script&lang=js"
export * from "./RoundCard.vue?vue&type=script&lang=js"

import "./RoundCard.vue?vue&type=style&index=0&id=c91f04a6&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91f04a6"]])

export default __exports__